
export const isDevelopmentEnvironment = () => {
    return process.env?.NODE_ENV == 'development';
}